import type { StorageEntityInfo } from '../types/warehouse.types';

// Group entities so records stacked on one physical pallet (same stack_group_id) go together
export const groupByStack = (storageEntities: StorageEntityInfo[]): StorageEntityInfo[][] => {
  const groups = new Map<string, StorageEntityInfo[]>();
  storageEntities.forEach((entity, index) => {
    // unstacked entities get a unique key -> stay singleton groups
    const key = entity.stack_group_id ?? `single-${index}`;
    const group = groups.get(key);
    if (group) {
      group.push(entity);
    } else {
      groups.set(key, [entity]);
    }
  });
  return Array.from(groups.values());
};
